/**
 * <Permissions 
 *		// please describe props here
 *	/>
 *
 * This is ...
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import locale from './locale.js';
import {cloneDeep, each} from 'lodash';
import alert from 'util/alert';
import confirm from 'util/confirm';

import SelectTeacher from 'template/Modals/SelectTeacher';
import parallel from 'run-parallel';
import './Permissions.scss';

import getPermissionGroupList from 'controllers/permission/getPermissionGroupList'
import getPermissionGroupDetail from 'controllers/permission/getPermissionGroupDetail'
import getPermissionList from 'controllers/permission/getPermissionList';
import registerPermissionGroup from 'controllers/permission/registerPermissionGroup'
import updatePermissionGroupTeacher from 'controllers/permission/updatePermissionGroupTeacher'
import deletePermissionGroup from 'controllers/permission/deletePermissionGroup'
import updatePermissionGroup from 'controllers/permission/updatePermissionGroup'

const GROUP_ORDER = [
  'timetable_channel',
  'student_channel',
  'read_student_detail',
  'class_channel',
  'private_class_channel',
  'teacher_channel',
  'classroom_channel',
  'announcement_channel',
  'finance_channel',
  'poster_channel',
  'contact_channel',
  'school_setting_channel',
  'group_perm_channel',
  'nav_bar',
  'operation_log_channel',
];

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => {
  return {

  };
};

class Permissions extends React.Component {
  constructor(props) {
    super(props);
 
    this.schoolId = localStorage.getItem('schoolId');
  
    this.state = {
      currentGroup: {},
      groupList: [],
      permissionList: [],
      mode: 'read',
      permissionGroups: {},

      permissionFormData: [],
      teachersFormData: [],
      schema: [],
  
      expandedGroup: {},
    };
    
    this.propagatedPermissionChange = {};

    this.toggleMode = this.toggleMode.bind(this);
    this.addMember = this.addMember.bind(this);
    this.removeMember = this.removeMember.bind(this);
    this.onPermissionChange = this.onPermissionChange.bind(this);
    this.onPermissionNameChange = this.onPermissionNameChange.bind(this); 
    this.onSelectGroup = this.onSelectGroup.bind(this); 
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
    this.savePermissions = this.savePermissions.bind(this);
    this.saveTeachers = this.saveTeachers.bind(this);
    this.createGroup = this.createGroup.bind(this);
  }

  componentWillMount() {
    this.getPermissionGroupList();
    this.getPermissionList();
  }

  getPermissionGroupDetail(groupId) {
    getPermissionGroupDetail(groupId)
      .then((res)=>{

        let currentGroup = cloneDeep(res.data);
        
        currentGroup.teachers = currentGroup.teachers || [];

        this.setState({
          currentGroup,
          // we will basically merge group in group list with the new group detail
          groupList: this.state.groupList.map((group)=>{
            if (groupId === group.id) {
              return {
                ...currentGroup,
              }
            }
            return group;
          })
        }, ()=>{
          this.prepareEdit();
        });
      })
      .catch((error)=>{
        console.error(error);
      });
  }

  prepareEdit() {
    const {
      currentGroup,
    } = this.state;

    let newExpandedGroup = {} 

    let permissionFormData = {}

    currentGroup.permissions.map((id, index)=>{
      permissionFormData[id] = true;
      if (typeof newExpandedGroup[id] == 'undefined') {
        newExpandedGroup[id] = true;
      }
    });

    let teachersFormData = [];

    currentGroup.teachers.map(({ id, stName, stGender })=>{
      teachersFormData.push({
        id,
        name: stName,
        gender: stGender,
      });
    });

    this.setState({
      currentGroup,
      expandedGroup: {
        ...this.state.expandedGroup,
        ...newExpandedGroup,
      }, 
      permissionName: currentGroup.name,
      permissionFormData,
      teachersFormData,
    });

  }

  getPermissionGroupList() {
    getPermissionGroupList(this.schoolId)
      .then((res)=>{
        if (Array.isArray(res.data)) {
          this.setState({
            groupList: res.data,
          }, ()=>{

            if (!this.state.currentGroup.id) {
              this.getPermissionGroupDetail(res.data[0].id);
            }
          });
        }
      })
      .catch((err)=>{
        console.error(err);
      });
  }

  getPermissionList() {
    const BY_CHANNEL = false;
    getPermissionList(BY_CHANNEL)
      .then((res)=>{
        if (Array.isArray(res.data)) {
          const { 
            permissionDep, 
            permissionsDepOn, 
          } = this.getPermissionDep(res.data);

          let permissionsPerId = {} 

          res.data.map((perm)=>{
            permissionsPerId[perm.id] = perm;
          });
          
          this.setState({
            permissionList: res.data,
            permissionsPerId,
            permissionDep,
            permissionsDepOn, 
          }, ()=>{
            const schema = this.reorderPermissionGroups(); 
          });
        }
      })
      .catch((err)=>{
        console.error(err);
      });
  }
  
  reorderPermissionGroups() {
    const {
      permissionList,
    } = this.state;
    let permissionGroups = {};

    let types = {
      read: [],
      create: [],
      update: [],
      delete: [],
      others: [],
    }
    // Step 1. Put permissions in read, create, update, delete order
    permissionList.map((perm)=>{
      if (perm.codename.indexOf('read') > -1) {
        types.read.push(perm);
      } else if (perm.codename.indexOf('create') > -1) {
        types.create.push(perm);
      } else if (perm.codename.indexOf('edit') > -1) {
        types.update.push(perm);
      } else if (perm.codename.indexOf('delete') > -1) {
        types.delete.push(perm);
      } else {
        types.others.push(perm);
      }
    });

    let sortedPermissionList = [...types.read, ...types.create, ...types.update, ...types.delete, ...types.others];

    // Step 2. Allocate permissions into each group
    sortedPermissionList.map(function(perm, idx) {
      if (Array.isArray(perm.belong_to)) {
        perm.belong_to.map((parent, idx)=>{
          if (!permissionGroups[parent]) {
            permissionGroups[parent] = {
              children: [],
            };
          }

          // if the perm's belong_to's name is same as code_name
          // we assuem this perm is a parent(channel) perm
          if (parent === perm.codename) {
            permissionGroups[parent] = {
              ...permissionGroups[parent],
              ...perm,
            }
          } else {
            permissionGroups[parent].children.push(perm);
          }
          
        });
      }
    });
    

    // Step 3. Reorder permission groups according to menu order
    let ordered = {}
    GROUP_ORDER.map((name)=>{
      if (permissionGroups[name]) {
        ordered[name] = permissionGroups[name];
      }
    });

    each(permissionGroups, (value, name)=>{
      if (!ordered[name]) {
        ordered[name] = value;
      }  
    });

    this.setState({
      permissionGroups: ordered, 
    });
  
  }

  getPermissionDep(permissions) {

    // flat out permissions to {name}: {id} format
    const idPerName = {};
    permissions.map((perm)=>{
      idPerName[perm.codename] = perm.id;
    });

    // dependency
    let permissionDep = {}
    permissions.map((perm)=>{
      const {
        depend_on,
      } = perm;

      let depArray = [];
      depend_on.map((name)=>{
        if (idPerName[name]) {
          depArray.push(idPerName[name]);    
        }
      });

      permissionDep[perm.id] = depArray;
    });

    // affect
    let permissionsDepOn = {}
    each(permissionDep, (deps, id)=>{ 
      deps.map((depId)=>{
        if (!permissionsDepOn[depId]) {
          permissionsDepOn[depId] = [];
        }

        permissionsDepOn[depId].push(parseInt(id));
      });
    });

    return { 
      permissionDep, 
      permissionsDepOn,
    }
  }

  onPermissionChange( permissionFormData) {
    this.setState({
      permissionFormData: {
        ...this.state.permissionFormData,
        ...permissionFormData,
        ...this.propagatedPermissionChange,
      },
      expandedGroup: {
        ...this.state.expandedGroup,
        ...permissionFormData,
      }
    }, ()=>{
      this.propagatedPermissionChange = {};
    });
  }

  onTogglePermission(e, id, value) {
    const {
      permissionFormData = {},
      currentDep = [],
      currentDepOn = [],
      permissionsPerId,
    } = this.state;
    const onPermissionChange = this.onPermissionChange;
    
    const affectedDep = currentDep.filter((id, key)=>{
      return permissionFormData[id] !== true; 
    })
    
    const affectedDepOn = currentDepOn.filter((id, key)=>{
      return permissionFormData[id] === true; 
    })

    if (value === true && affectedDepOn.length > 0) {
      e.preventDefault(); 
      confirm(<p>
          <b>{__('The following permissions will be disabled in order to complete your request.', locale)}</b>
          <ul>
            {affectedDepOn.map((id, key)=>{
              return <li key={key}>{key + 1}. {__(permissionsPerId[id].description, locale)}</li>
            })}
          </ul>
        </p>, __('Warning', locale))
      .then(()=>{
        currentDepOn.map((id)=>{
          this.propagatedPermissionChange[id] = false;
        });
        onPermissionChange({ [id]: false });
      })
      .catch(()=>{});
    } else if (value !== true && affectedDep.length > 0) {
      e.preventDefault();

      confirm(<p>
          <b>{__('The following permissions will be enabled in order to complete your request.', locale)}</b>
          <ul>
            {affectedDep.map((id, key)=>{
              return <li key={key}>{key + 1}. {__(permissionsPerId[id].description, locale)}</li>
            })}
          </ul>
        </p>, __('Warning', locale))
      .then(()=>{
        currentDep.map((id)=>{
          this.propagatedPermissionChange[id] = true;
        });
        onPermissionChange({ [id]: true, });
      })
      .catch(()=>{});
    } else {
      onPermissionChange({ [id]: value !== true });
    }

  }

  generatePermissionForm() {
    const {
      permissionGroups,
      
      mode,
      currentDep = [], 
      currentDepOn = [],

      permissionDep,
      permissionsDepOn,

      permissionFormData,

      expandedGroup,
    } = this.state;
    // TODO: refactor it as a separate component
    const CheckBox = ({ id, hideCheckbox, description, value, className, disabled, codename })=>{
      return <div className={classnames(className, 'codename--' + codename, 'Field form-group field-style-outline')}>
        <label
        className={classnames({
          'control': true,
          active: value,
          dep: value !== true && currentDep.indexOf(id) > -1, 
          depOn: value == true && currentDepOn.indexOf(id) > -1,
        })}
        onMouseEnter={()=>{
          this.setState({
            ...this.state,
            currentDep: value != true ? (permissionDep[id] || []) : [], 
            currentDepOn: value == true ? (permissionsDepOn[id] || []) : [], 
          });
        }}
        onMouseLeave={()=>{
          this.setState({
            ...this.state,
            currentDep: [],
            currentDepOn: [], 
          });
        }}
        onClick={()=>{
          if(hideCheckbox) {
            this.setState({
              expandedGroup: {
                ...expandedGroup,
                [id]: expandedGroup[id] !== true,
              }
            });
          }
        }}
      >
        { hideCheckbox !== true &&
          <input 
            type='checkbox' 
            checked={value} 
            value={value} 
            disabled={disabled} 
            onChange={(e)=>{ 
              this.onTogglePermission(e, id, value); 
            }} 
          />
        }
        { hideCheckbox !== true && <span className="checkmark"></span> }
          {__(description, locale)} 
        </label>
      </div>
    }

    let formItems = []; 

    let disabled = mode !== 'edit'; 

    each(permissionGroups, (group, codename)=>{
      const {
        id,
        children,
        description,
      } = group;

      let groupValue = permissionFormData[id];
      //
      // "nav_bar" is always checked and cannot be modified: START
      //
      const isNavBar = codename === 'nav_bar';
      if (isNavBar) {
        groupValue = true;
      }
      //
      // "nav_bar" is always checked: END
      //

      const expanded = expandedGroup[id] == true;
      
      formItems.push(<div className={classnames({ active: groupValue || isNavBar }, 'permissions--group', 'codename--' + codename)}>
        <div className='group--header'>
          {CheckBox({ ...group, hideCheckbox: isNavBar, codename, value: groupValue, disabled, className: 'group--checkbox' })}
          <a className='btn-link toggle-expand' onClick={()=>{
              this.setState({
                expandedGroup: {
                  ...expandedGroup,
                  [id]: expandedGroup[id] !== true,
                }
              });
            }}><i className={classnames('fa', {'icon-angle-right': !expanded, 'icon-angle-down': expanded })}></i></a>
        </div>

        <div className={classnames('permissions--group--children', { expanded })}>
          {children.map((perm)=>{
            const { 
              id, 
              description,
              codename,
            } = perm;
            
            const value = permissionFormData[id];
            
            return CheckBox({ ...perm, value, codename, disabled, className: 'children--checkbox'}); 
          })}
        </div>  
      </div>);
    });

    return (
      <form className='Form'>
        {formItems}
      </form>
    );
    
  }

  createGroup() {
    this.setState({
      currentGroup: {
        id: -1,
        description: '',
        name: '',
        permissions: [],
        teachers: [],
      }
    }, ()=>{
      this.toggleMode();
    });
  }

  addMember() {
    const {
      teachersFormData,
    } = this.state;

    SelectTeacher({ 
      schoolId: this.schoolId,
      selected: cloneDeep(teachersFormData),
      selectMultiple: true,
    })
      .then((selected)=>{
        const teachersFormData = selected.map(({ name, id, gender, })=>{
          return {
            name, id, gender
          };
        });

        this.setState({
          teachersFormData,
        });
      });
  }

  onSelectGroup(currentGroup) {
    return ()=>{
      this.setState({
        currentGroup,
      });
        
      this.getPermissionGroupDetail(currentGroup.id)
    }
  }

  toggleMode() {
    const mode = this.state.mode === 'edit' ? 'read' : 'edit';

    const {
      currentGroup,
      groupList,
    } = this.state;

    this.setState({
      mode,
    }, ()=>{
      if (mode == 'edit') {
        this.prepareEdit();
        this.reorderPermissionGroups();

        if (currentGroup.id === -1 && this.permissionNameRef) {
          this.permissionNameRef.focus();
        }
      }

      if (mode == 'read') {
        
        // when currentGroup id is -1 which means it's temporary group for "create"
        // we go back to the last group
        if (currentGroup.id === -1) {
          this.setState({
            currentGroup: groupList[0],
          }, ()=>{
            this.prepareEdit();
          });
        } else {
          
          this.prepareEdit();
        
        }
      
      }
    });
  }

  removeMember(index) {
    return ()=>{
      this.setState({
        teachersFormData: this.state.teachersFormData.filter((data, i)=> { return i != index})
      });
    }
  }

  onPermissionNameChange(e) {
    this.setState({
      permissionName: e.target.value,
    });
  }

  remove() {
    const {
      currentGroup,
    } = this.state;

    confirm(__('This permission group will be deleted permanently.', locale), __('Deleting Permission Group', locale))
      .then(()=>{
        deletePermissionGroup(currentGroup.id)
          .then((res)=>{
            if (res.data && res.data.result === 'success') {
              this.setState({
                currentGroup: {},
              }, ()=>{
                this.toggleMode();
                this.getPermissionGroupList();
              });
            } else {
              console.error(res);
            }
          })
          .catch((err)=>{
            console.error(err);
          });
      });

  }

  save() {
    const {
      currentGroup,
      permissionFormData,
    } = this.state;

    this.setState({
      saving: true,
    });

    // Step 1: START
    let permissions = [];

    Object.keys(permissionFormData).map((id)=>{
      if (permissionFormData[id]) {
        permissions.push(parseInt(id));
      }
    })

    if (permissions.length == 0) {
      alert.warning(__('Permission must not be empty.', locale), '');
      this.setState({
        saving: false,
      });
      return;
    } 
    // Step 1: END

    // updating
    if (currentGroup.id > -1) {
      parallel([
        (done)=>{
          this.savePermissions(permissions, done);
        },    
        this.saveTeachers,
      ],
      (err, result)=>{
        
        if (result.indexOf(false) > -1 || err) {
          alert.warning(__('There is an error, please try again', locale), __('Failed to save', locale));    
          this.setState({
            saving: false,
          });
  
        } else {
          alert.success('', __('Settings Saved', locale)); 
          this.setState({
            saving: false,
          });

          this.getPermissionGroupDetail(currentGroup.id);
          
          this.toggleMode();
        }
      });
    }

    if (currentGroup.id === -1) {
      // registering
      this.registerPermissions(permissions)
    }
  }

  registerPermissions(permissions) {
    const {
      permissionName,
    } = this.state;

    registerPermissionGroup(this.schoolId, {
      name: permissionName,
      description: '--', // it's empty for now
      permissions,
    })
      .then((res)=>{
        this.setState({
          saving: false,
        });

        if (res && res.data && res.data.group_id) {
          this.setState({
            currentGroup: {
              ...this.state.currentGroup,
              id: res.data.group_id,
            }
          }, ()=>{
            this.saveTeachers((err, result)=>{

              if (err) {
                console.error(err);
              } else if (result) {
                alert.success('', __('New permission group created', locale)); 
                this.getPermissionGroupDetail(this.state.currentGroup.id);
                this.getPermissionGroupList();
                this.toggleMode();
              }
            });
          });
        } else {
          console.error(res);
        }
      })
      .catch(()=>{
        console.error(err);
      });
  }

  savePermissions(permissions, done) {
    const {
      permissionName,
      permissionFormData = {},
      currentGroup,
    } = this.state;

    updatePermissionGroup(currentGroup.id, {
      name: permissionName,
      description: currentGroup.desciption,
      permissions,
    })
      .then((res)=>{
        if (res.data) {
          const {
            result,
            reason,
          } = res.data;

          // failed
          if (result === 'failure') {
            done(res.data, false);
          } else {
          // success
            done(null, true);
          }
        }
      })
      .catch((err)=>{
        console.error(err);
        done(err, false);
      });
  }

  saveTeachers(done) {
    const {
      teachersFormData = {},
      currentGroup,
    } = this.state;

    updatePermissionGroupTeacher(this.schoolId, {
      teacher_id_list: teachersFormData.map((teacher)=>{
        return teacher.id;
      }),
      group_id_list: [currentGroup.id],
    })
      .then((res)=>{
        if (res.data && res.data.result && res.data.result.indexOf('success') > -1) {
          done(null, true);
        } else {
          done(res.data, false)
        }
      })
      .catch((error)=>{
        done(error, false);
      });
  }

  render() {
    const {
      mode,
      groupList,
      currentGroup,
      teachersFormData,
      saving,
    } = this.state;

    const {
      name,
    } = currentGroup;

    const isCreating = currentGroup.id === -1;

    let {
      permissionName,
    } = this.state;

    if (permissionName === 'Teachers') {
      permissionName = __('Teachers', locale);
    }

    return (
      <div className={classnames('Permissions', 'mode-' + mode)}>
        <div className='row'>
          <div className='col-xs-2 Permissions-list-column'>
            { 
              mode === 'read' && 
                <a className='btn btn-primary' onClick={this.createGroup}>
                  <i className='fa icon-plus'></i>{__('Create Group', locale)}
                </a> 
            }
            { 
              mode === 'read' && 
                <ul className='groupList'>
                  {groupList.map((group, key)=>{
                    let { name } = group;
                    if (name === 'Teachers') {
                      name = __('Teachers', locale);
                    }
                    return <li className={classnames('GroupList--item', { active: group.id == currentGroup.id, })} key={key} onClick={this.onSelectGroup(group)} >{name}<i className='fa icon-angle-right'></i></li>
                  })}
                </ul>
            }
            { 
              !isCreating && mode === 'edit' &&
                <h3>{__('Edit Group', locale)}</h3>
            }
            {
              isCreating &&
              <h3>{__('Create Group', locale)}</h3>
            }
          </div>
          <div className='col-xs-10 Permissions-content-column'>
            
            { mode === 'read' && <section className='Permissions--header Permissions--header__read'>
              <h2>{permissionName}</h2>
              <button className='btn btn-primary pull-right' onClick={this.toggleMode}><i className='fa icon-cog'></i>{__('Edit Group', locale)}</button>
            </section> }
            
            { mode === 'edit' && <section className='Permissions--header Permissions--header__edit'>
              { 
                name !== 'Teachers' && 
                  <div className='form-group'>
                    <input className='form-control' placeholder={__('Permission Group Name', locale)} ref={(r)=>{ this.permissionNameRef = r; }} onChange={this.onPermissionNameChange} value={permissionName} />
                  </div> 
              }
              { 
                name === 'Teachers' && <h2>{permissionName}</h2> 
              }
              <div className ='pull-right'> 
                <button className='btn btn-primary' disabled={saving} onClick={this.save}>{__('Save', locale)}</button>
                <button className='btn' onClick={this.toggleMode}>{__('Cancel', locale)}</button>
                { !isCreating && name !== 'Teachers' && <button className='btn btn-danger pull-right' onClick={this.remove}>{__('Delete Permission Group', locale)}</button> } 
                </div> </section> 
            }
            
            <section className='PermissionList'>
              {this.generatePermissionForm()}
            </section>
            
            <section className='Members'>
              { mode === 'edit' && <button className='pull-right btn btn-primary' onClick={this.addMember}>{__('Add Member', locale)}</button> }
              <h4>{__('Group Member', locale)}</h4> 
              <ul className='MemberList'>
                {Array.isArray(currentGroup.teachers) && 
                  teachersFormData.map((member, key)=>{
                    const {
                      id,
                      name,
                      gender,
                    } = member;
                    return ( 
                      <li className='col-sm-3 MemberList--item' key={key}>{name} 
                        { mode === 'edit' && <a onClick={this.removeMember(key)}><i className='fa icon-cancel'></i></a> }
                      </li>
                      );
                  })}
              </ul>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Permissions);



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolSettings/Permissions/index.js